/* eslint-disable @typescript-eslint/ban-ts-comment */
import { Form, Input, Select } from "antd";
import { FormInstance } from "antd/lib";

import { PrimaryText } from "@/components/Typography/Styled";
import { useAppSelector } from "@/hooks/redux";

import { StyledForm } from "./Styled";

export interface RouteEditorFormValues {
    routeName: string;
    routeAgent: string;
}

export default function RouteEditorForm({
    form,
    showAgentField = true,
}: {
    form: FormInstance<RouteEditorFormValues>;
    showAgentField?: boolean;
}) {
    const { team } = useAppSelector((state) => state.sv);

    return (
        <StyledForm form={form} layout="vertical">
            <Form.Item
                label={<PrimaryText>Введіть назву нового маршруту</PrimaryText>}
                name="routeName"
                rules={[{ required: true, message: "Введіть назву маршруту" }]}
            >
                <Input placeholder="Введіть назву маршруту" size="large" />
            </Form.Item>

            {showAgentField && (
                <Form.Item
                    label={<PrimaryText>Оберіть виконавця</PrimaryText>}
                    name="routeAgent"
                    rules={[{ required: true, message: "Оберіть виконавця" }]}
                >
                    <Select placeholder="ПІБ" size="large">
                        {team?.members?.map((item) => (
                            <Select.Option
                                key={item.userId}
                                value={item.userId}
                            >
                                {item.fullName}
                            </Select.Option>
                        ))}
                    </Select>
                </Form.Item>
            )}
        </StyledForm>
    );
}
